/* ==========================================================================
   JGS Boutique theme JS — vanilla, no framework.
   - Smooth-scroll for in-page anchors (#shop) that works from any
     template (redirects home first, then scrolls).
   - Mobile hamburger nav open/close.
   - Cart drawer: open/close, Ajax Cart API add/change/remove, live totals.
   - Toast helper (ported from the mockup) for the email capture form.
   - Header search: predictive results from /search/suggest.json.
   - Instagram video reel: arrow paging + tap-to-play lightbox.
   ========================================================================== */
(function () {
  'use strict';

  /* ---------------- toast ---------------- */
  var toast = document.getElementById('toast');
  var toastTimer;
  function showToast(msg) {
    if (!toast) return;
    toast.textContent = msg;
    toast.style.display = 'block';
    requestAnimationFrame(function () { toast.classList.add('show'); });
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () {
      toast.classList.remove('show');
      setTimeout(function () { toast.style.display = 'none'; }, 300);
    }, 3200);
  }
  window.JGS = window.JGS || {};
  window.JGS.showToast = showToast;

  /* ---------------- smooth-scroll anchors ---------------- */
  var SECTION_IDS = ['shop'];

  function isHomepage() {
    return document.body.getAttribute('data-template') === 'index';
  }

  document.addEventListener('click', function (e) {
    var link = e.target.closest('a[href]');
    if (!link) return;
    var href = link.getAttribute('href');
    if (!href) return;

    var hashIdx = href.indexOf('#');
    if (hashIdx === -1) return;
    var id = href.slice(hashIdx + 1);
    if (!id || SECTION_IDS.indexOf(id) === -1) return;

    var pathPart = href.slice(0, hashIdx);
    var targetsHome = pathPart === '' || pathPart === '/' || pathPart === window.location.pathname;

    if (targetsHome && isHomepage()) {
      var el = document.getElementById(id);
      if (el) {
        e.preventDefault();
        el.scrollIntoView({ behavior: 'smooth', block: 'start' });
        closeMobileNav();
      }
    }
    // otherwise let the browser navigate normally to /#id
  }, false);

  /* ---------------- mobile nav ---------------- */
  var hamburger = document.querySelector('[data-mobile-nav-toggle]');
  var mobileNav = document.querySelector('[data-mobile-nav]');
  var mobileNavOverlay = document.querySelector('[data-mobile-nav-overlay]');
  var mobileNavClose = document.querySelector('[data-mobile-nav-close]');

  function openMobileNav() {
    if (!mobileNav) return;
    mobileNav.classList.add('open');
    if (mobileNavOverlay) mobileNavOverlay.classList.add('open');
    if (hamburger) hamburger.setAttribute('aria-expanded', 'true');
    document.documentElement.style.overflow = 'hidden';
  }
  function closeMobileNav() {
    if (!mobileNav) return;
    mobileNav.classList.remove('open');
    if (mobileNavOverlay) mobileNavOverlay.classList.remove('open');
    if (hamburger) hamburger.setAttribute('aria-expanded', 'false');
    document.documentElement.style.overflow = '';
  }
  if (hamburger) {
    hamburger.addEventListener('click', function () {
      var expanded = hamburger.getAttribute('aria-expanded') === 'true';
      if (expanded) { closeMobileNav(); } else { openMobileNav(); }
    });
  }
  if (mobileNavClose) mobileNavClose.addEventListener('click', closeMobileNav);
  if (mobileNavOverlay) mobileNavOverlay.addEventListener('click', closeMobileNav);
  document.querySelectorAll('[data-mobile-nav] a').forEach(function (a) {
    a.addEventListener('click', function () {
      // let anchor-scroll handler run; just close the panel
      setTimeout(closeMobileNav, 50);
    });
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { closeMobileNav(); closeCart(); }
  });

  /* ---------------- cart drawer ---------------- */
  var cartDrawer = document.querySelector('[data-cart-drawer]');
  var cartOverlay = document.querySelector('[data-cart-overlay]');
  var cartBody = document.querySelector('[data-cart-body]');
  var cartCountEls = document.querySelectorAll('[data-cart-count]');
  var cartSubtotalEls = document.querySelectorAll('[data-cart-subtotal]');
  var cartOpenTriggers = document.querySelectorAll('[data-cart-open]');
  var cartCloseTriggers = document.querySelectorAll('[data-cart-close]');

  function moneyFromCents(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  function openCart() {
    if (!cartDrawer) return;
    cartDrawer.classList.add('open');
    if (cartOverlay) cartOverlay.classList.add('open');
    document.documentElement.style.overflow = 'hidden';
  }
  function closeCart() {
    if (!cartDrawer) return;
    cartDrawer.classList.remove('open');
    if (cartOverlay) cartOverlay.classList.remove('open');
    document.documentElement.style.overflow = '';
  }
  cartOpenTriggers.forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      openCart();
      renderCart();
    });
  });
  cartCloseTriggers.forEach(function (btn) { btn.addEventListener('click', closeCart); });
  if (cartOverlay) cartOverlay.addEventListener('click', closeCart);

  function updateCartCount(count) {
    cartCountEls.forEach(function (el) {
      el.textContent = count;
      el.hidden = count === 0;
    });
  }

  function lineItemMarkup(item) {
    var variantLine = (item.variant_title && item.variant_title !== 'Default Title')
      ? '<div class="cart-line-variant">' + item.variant_title + '</div>' : '';
    return (
      '<div class="cart-line" data-line-key="' + item.key + '">' +
        '<div class="cart-line-photo">' +
          (item.image ? '<img src="' + item.image + '" alt="" loading="lazy">' : '') +
        '</div>' +
        '<div class="cart-line-info">' +
          '<div class="cart-line-title">' + item.product_title + '</div>' +
          variantLine +
          '<div class="cart-line-row">' +
            '<div class="cart-qty">' +
              '<button type="button" data-cart-decrease>&minus;</button>' +
              '<span>' + item.quantity + '</span>' +
              '<button type="button" data-cart-increase>+</button>' +
            '</div>' +
            '<div class="cart-line-price">' + moneyFromCents(item.final_line_price) + '</div>' +
          '</div>' +
          '<button type="button" class="cart-line-remove" data-cart-remove>Remove</button>' +
        '</div>' +
      '</div>'
    );
  }

  function renderCartFromData(cart) {
    updateCartCount(cart.item_count);
    cartSubtotalEls.forEach(function (el) { el.textContent = moneyFromCents(cart.total_price); });

    if (!cartBody) return;
    if (!cart.items.length) {
      cartBody.innerHTML = '<div class="cart-empty">Your cart is empty.</div>';
      return;
    }
    cartBody.innerHTML = cart.items.map(lineItemMarkup).join('');
  }

  function fetchCart() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); });
  }

  function renderCart() {
    fetchCart().then(renderCartFromData).catch(function () {});
  }

  function changeLine(key, quantity) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    }).then(function (r) { return r.json(); }).then(renderCartFromData);
  }

  if (cartBody) {
    cartBody.addEventListener('click', function (e) {
      var line = e.target.closest('[data-line-key]');
      if (!line) return;
      var key = line.getAttribute('data-line-key');
      var qtyEl = line.querySelector('.cart-qty span');
      var qty = parseInt(qtyEl ? qtyEl.textContent : '1', 10) || 1;

      if (e.target.closest('[data-cart-increase]')) {
        changeLine(key, qty + 1);
      } else if (e.target.closest('[data-cart-decrease]')) {
        changeLine(key, Math.max(0, qty - 1));
      } else if (e.target.closest('[data-cart-remove]')) {
        changeLine(key, 0);
      }
    });
  }

  // Intercept any "Add to cart" form (product page, quick-add) site-wide.
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.matches('form[data-add-to-cart-form]')) return;
    e.preventDefault();

    var submitBtn = form.querySelector('[type="submit"]');
    var originalText = submitBtn ? submitBtn.textContent : '';
    if (submitBtn) { submitBtn.textContent = 'Adding…'; submitBtn.disabled = true; }

    var formData = new FormData(form);

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { Accept: 'application/json' },
      body: formData
    })
      .then(function (r) {
        if (!r.ok) return r.json().then(function (err) { throw err; });
        return r.json();
      })
      .then(function () {
        renderCart();
        openCart();
        showToast('Added to your cart.');
      })
      .catch(function (err) {
        showToast((err && err.description) || 'Could not add that item to your cart.');
      })
      .finally(function () {
        if (submitBtn) { submitBtn.textContent = originalText; submitBtn.disabled = false; }
      });
  });

  // Initial cart state on every page load.
  document.addEventListener('DOMContentLoaded', function () {
    fetchCart().then(function (cart) { updateCartCount(cart.item_count); }).catch(function () {});
  });

  /* ---------------- email capture (Shopify customer form handles the
     real submission; this just shows the confirmation toast the mockup
     used, once Shopify's own redirect/AJAX response comes back). ---------- */
  var captureForm = document.getElementById('captureForm');
  if (captureForm) {
    captureForm.addEventListener('submit', function () {
      // Shopify customer contact forms submit normally (or via their own
      // accept-marketing flow); show the confirmation toast optimistically.
      showToast('Thanks — you are on the list.');
    });
  }

  /* ---------------- product page quantity selector ---------------- */
  document.querySelectorAll('[data-qty-selector]').forEach(function (wrap) {
    var input = wrap.querySelector('input');
    var minus = wrap.querySelector('[data-qty-minus]');
    var plus = wrap.querySelector('[data-qty-plus]');
    if (!input) return;
    if (minus) minus.addEventListener('click', function () {
      input.value = Math.max(1, (parseInt(input.value, 10) || 1) - 1);
    });
    if (plus) plus.addEventListener('click', function () {
      input.value = (parseInt(input.value, 10) || 1) + 1;
    });
  });
  /* ---------------- header search (predictive) ---------------- */
  var searchToggle = document.querySelector('[data-search-toggle]');
  var searchPanel = document.querySelector('[data-search-panel]');
  var searchInput = document.querySelector('[data-search-input]');
  var searchResults = document.querySelector('[data-search-results]');
  var searchForm = searchInput.form;
  var suggestTimer, suggestSeq = 0, selected = -1;

  function openSearch() {
    closeMobileNav();
    searchPanel.hidden = false;
    searchToggle.setAttribute('aria-expanded', 'true');
    searchInput.focus();
  }
  function closeSearch() {
    searchPanel.hidden = true;
    searchToggle.setAttribute('aria-expanded', 'false');
  }
  function searchAllUrl(q) {
    return searchForm.action + '?type=product&q=' + encodeURIComponent(q);
  }
  function suggestRow(href, inner, cls) {
    var li = document.createElement('li');
    li.setAttribute('role', 'presentation');
    var a = document.createElement('a');
    a.href = href;
    a.setAttribute('role', 'option');
    if (cls) a.className = cls;
    a.innerHTML = inner;
    li.appendChild(a);
    return li;
  }
  function escapeHtml(str) {
    var d = document.createElement('div');
    d.textContent = str;
    return d.innerHTML;
  }
  function renderSuggest(q, products) {
    searchResults.innerHTML = '';
    selected = -1;
    if (!products.length) {
      var empty = document.createElement('li');
      empty.className = 'r-empty';
      empty.textContent = 'No products match “' + q + '”.';
      searchResults.appendChild(empty);
    }
    products.forEach(function (p) {
      var img = p.image ? p.image + (p.image.indexOf('?') === -1 ? '?' : '&') + 'width=104' : '';
      searchResults.appendChild(suggestRow(p.url,
        '<span class="r-photo">' + (img ? '<img src="' + img + '" alt="" loading="lazy">' : '') + '</span>' +
        '<span class="r-text"><span class="r-brand">' + escapeHtml(p.vendor) + '</span><span class="r-label">' + escapeHtml(p.title) + '</span></span>' +
        '<span class="r-price">$' + Number(p.price).toFixed(2) + '</span>'));
    });
    searchResults.appendChild(suggestRow(searchAllUrl(q), '<span>See all results for “' + escapeHtml(q) + '”</span><span>&rarr;</span>', 'r-all'));
    Array.prototype.forEach.call(searchResults.querySelectorAll('a'), function (a, i) { a.id = 'search-opt-' + i; });
    searchInput.setAttribute('aria-expanded', 'true');
    searchInput.removeAttribute('aria-activedescendant');
  }
  function fetchSuggest(q) {
    var seq = ++suggestSeq;
    var url = searchInput.getAttribute('data-suggest-url') + '?q=' + encodeURIComponent(q) +
      '&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last';
    fetch(url, { headers: { Accept: 'application/json' } })
      .then(function (r) {
        if (!r.ok) throw new Error('Predictive search failed: HTTP ' + r.status);
        return r.json();
      })
      .then(function (data) {
        if (seq === suggestSeq) renderSuggest(q, data.resources.results.products);
      });
  }
  function selectOption(i) {
    var opts = searchResults.querySelectorAll('a');
    if (!opts.length) return;
    if (selected > -1) opts[selected].removeAttribute('aria-selected');
    selected = (i + opts.length) % opts.length;
    opts[selected].setAttribute('aria-selected', 'true');
    opts[selected].scrollIntoView({ block: 'nearest' });
    searchInput.setAttribute('aria-activedescendant', opts[selected].id);
  }

  searchToggle.addEventListener('click', function () { searchPanel.hidden ? openSearch() : closeSearch(); });
  document.querySelector('[data-search-close]').addEventListener('click', function () { closeSearch(); searchToggle.focus(); });
  searchInput.addEventListener('input', function () {
    clearTimeout(suggestTimer);
    var q = searchInput.value.trim();
    if (!q) {
      suggestSeq++;
      searchResults.innerHTML = '';
      searchInput.setAttribute('aria-expanded', 'false');
      return;
    }
    suggestTimer = setTimeout(function () { fetchSuggest(q); }, 180);
  });
  searchInput.addEventListener('keydown', function (e) {
    if (e.key === 'ArrowDown') { e.preventDefault(); selectOption(selected + 1); }
    else if (e.key === 'ArrowUp') { e.preventDefault(); selectOption(selected - 1); }
    else if (e.key === 'Enter' && selected > -1) { e.preventDefault(); window.location.href = searchResults.querySelectorAll('a')[selected].href; }
    else if (e.key === 'Escape') { closeSearch(); searchToggle.focus(); }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === '/' && searchPanel.hidden && !/^(INPUT|TEXTAREA|SELECT)$/.test(document.activeElement.tagName)) {
      e.preventDefault();
      openSearch();
    }
  });

  /* ---------------- Instagram video reel + lightbox (homepage section) ---------------- */
  var reelTrack = document.querySelector('[data-reel-track]');
  if (reelTrack) {
    var reelPrev = document.querySelector('[data-reel-prev]');
    var reelNext = document.querySelector('[data-reel-next]');
    var reelPage = function () {
      var gap = parseFloat(getComputedStyle(reelTrack).columnGap);
      var card = reelTrack.firstElementChild.offsetWidth + gap;
      return card * Math.max(1, Math.floor((reelTrack.clientWidth + gap) / card));
    };
    var reelUpdate = function () {
      reelPrev.disabled = reelTrack.scrollLeft < 4;
      reelNext.disabled = reelTrack.scrollLeft + reelTrack.clientWidth >= reelTrack.scrollWidth - 4;
    };
    reelPrev.addEventListener('click', function () { reelTrack.scrollBy({ left: -reelPage() }); });
    reelNext.addEventListener('click', function () { reelTrack.scrollBy({ left: reelPage() }); });
    reelTrack.addEventListener('scroll', reelUpdate, { passive: true });
    window.addEventListener('resize', reelUpdate);
    reelUpdate();

    var videoDialog = document.querySelector('[data-video-dialog]');
    var videoPlayer = document.querySelector('[data-video-dialog-player]');
    reelTrack.addEventListener('click', function (e) {
      var trigger = e.target.closest('[data-video-open]');
      if (!trigger) return;
      videoPlayer.src = trigger.getAttribute('data-video-open');
      videoDialog.showModal();
      videoPlayer.play();
    });
    document.querySelector('[data-video-dialog-close]').addEventListener('click', function () { videoDialog.close(); });
    videoDialog.addEventListener('click', function (e) { if (e.target === videoDialog) videoDialog.close(); });
    videoDialog.addEventListener('close', function () {
      videoPlayer.pause();
      videoPlayer.removeAttribute('src');
      videoPlayer.load();
    });
  }
})();
